/** Per-mount options read from the host element's `data-*` attributes (FR-REG-01). */
export interface MountOptions {
  base: string;
  /** `data-ffs-form` public id (registration mode). */
  publicId: string | null;
  /** `data-ffs-reschedule` join token (reschedule mode). */
  rescheduleToken: string | null;
  /** `data-ffs-registered` join token: show a "You're registered" confirmation instead. */
  registeredToken: string | null;
  buttonText: string | null;
  email: string;
  firstName: string;
  /** `data-ffs-source="hosted"` → `X-FFS-Source: hosted`, flat card. */
  hosted: boolean;
  /** `data-ffs-flat`: no card border, background or padding, so the fields align with the page. */
  flat: boolean;
}

export function readOptions(host: Element, base: string): MountOptions {
  const attr = (name: string) => host.getAttribute(name)?.trim() || null;
  return {
    base,
    publicId: attr('data-ffs-form'),
    rescheduleToken: attr('data-ffs-reschedule'),
    registeredToken: attr('data-ffs-registered'),
    buttonText: attr('data-button-text') ?? attr('data-ffs-button-text'),
    email: attr('data-ffs-email') ?? '',
    firstName: attr('data-ffs-first-name') ?? '',
    hosted: attr('data-ffs-source') === 'hosted',
    flat: host.hasAttribute('data-ffs-flat'),
  };
}
